<!--
  ~ Copyright (C) 2022 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->

<app-sign-up
  [environmentConfig]="environmentConfig"
></app-sign-up>
